import {
  AuthService,
  CustomButton,
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  ToastService,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import React, { ReactNode } from "react";
import { InvoiceStatus } from "../../../shared/enums";
import { ContactReferenceModel } from "../../../shared/models";
import { InvoicePopupWrapper } from "../../../shared/styles";
import { InvoiceUtil } from "../../../shared/utils";
import { RenderContactInfo } from "../../../shared/components"; 
import { AccountSettingsStore } from "../../../shared/store";
import { InvoiceService } from "../../../shared/services";

type Props = {
  onClose: (refresh: boolean) => void;
  id: string;
  status: keyof typeof InvoiceStatus;
  contact: ContactReferenceModel;
  invoiceNumber: string;
  balance: number;
  dueDate: Date;
};
const CancelInvoicePopUp: React.FC<Props> = ({
  onClose,
  invoiceNumber,
  status,
  id,
  contact,
  balance,
  dueDate,
}) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  function row(label: string, rightContent: ReactNode) {
    return (
      <FlexContainer spacing={30} margin="15px">
        <CustomLabel> {label}</CustomLabel>
        <FlexContainer>{rightContent}</FlexContainer>
      </FlexContainer>
    );
  }

  function body() {
    const colors = InvoiceUtil.getColorsByStatus(status);
    return (
      <InvoicePopupWrapper className="cancel-payment-popup">
        <CustomLabel
          textAlign="center"
          className="full-width"
          fontSize={"18px"}
          margin="20px 0px 30px"
        >
          Do you want to <span className="red-text semi-bold">cancel</span> this
          Invoice?
        </CustomLabel>
        {row("Customer", <RenderContactInfo contact={contact} />)}
        {row("Invoice No", <CustomLabel> {invoiceNumber}</CustomLabel>)}
        {row(
          "Status",
          <CustomButton
            color={colors.color}
            bgColor={colors.bgColor}
            minWidth={"80px"}
            width="80px"
            fontSize="16px"
            fontWeight={"600"}
            borderRadius={"4px !important"}
          >
            {InvoiceStatus[status]}
          </CustomButton>
        )}
        {row(
          "Balance Due",
          <CustomLabel fontWeight={600}>
            ${AccountSettingsStore.formatAmount(balance)}
          </CustomLabel>
        )}
        {row(
          "Payment Due",
          <CustomLabel fontWeight={600}>
            {UtilityMethods.formatDateInString(dueDate)}
          </CustomLabel>
        )}

        <CustomLabel
          color="#FF0000"
          className="full-width"
          textAlign="center"
          margin="30px 0px 0px"
        >
          Cancelled Invoices can be Restored Later.
        </CustomLabel>
      </InvoicePopupWrapper>
    );
  }

  function onSubmit() {
    if (isAPIRequestPending) return;
    setAPIRequestPending(true);
    InvoiceService.cancelInvoice(AuthService.authData.accountId, id).subscribe({
      next: (response) => {
        setAPIRequestPending(false);
        if (response.result.success) {
          ToastService.showSuccess("Invoice Cancelled Successfully");
        }

        onClose(true);
      },
      error: () => {
        setAPIRequestPending(false);
        ToastService.showError("Error while Cancelling Invoice");
      },
    });
  }

  return (
    <ModalComponent
      title="Cancel Invoice"
      titleFontSize="22px"
      bodyPadding="40px 45px"
      showFooter={true}
      minHeight="240px"
      wrapperWidth="700px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      redHeader={true}
      blueHeader={false}
      footerHeight="auto"
      onClose={() => onClose(false)}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            disabled={isAPIRequestPending}
            minWidth="120px"
            height="30px"
            onClick={() => onSubmit()}
          >
            Cancel
          </RedButton>
          <RedButton
            primary
            minWidth="120px"
            height="30px"
            onClick={() => onClose(false)}
          >
            Do Not Cancel
          </RedButton>
        </FlexContainer>
      }
    >
      {body()}
    </ModalComponent>
  );
};

export default CancelInvoicePopUp;
